import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LabTestInfo from 'containers/request/Initial/LabTestInfo';
import LabTestResult from 'containers/request/Initial/LabTestResult';
import { Bubble, LoaderButton, ContinueLabel } from 'ctia-ui';
import { notifyMessages } from 'helpers/NotifyHelper';
import { updateRequest } from 'actions/request';
import { submitWizardStep } from 'actions/wizard';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { showNotice } from 'actions/notifier';

class LabInfo extends Component {
  validate() {
    const { cdmaLab } = this.props.request;
    // return cdmaLab > 0 && (cdmaLabPoc > 0 || cdmaLabPoc === '');
    return cdmaLab > 0;
  }

  onSaveClick = () => {
    const {
      startPreloader,
      finishPreloader,
      updateRequest,
      request,
      showNotice
    } = this.props;
    const { id, cdmaLab } = request;

    startPreloader().then(
      updateRequest({ id, primarylabid: cdmaLab })
        .then(finishPreloader)
        .then(showNotice(notifyMessages.requestUpdatedSuccessfully))
    );
  };

  render() {
    const {
      show,
      request,
      canSubmit,
      submitWizardStep,
      wizard,
      tests,
      user
    } = this.props;

    if (!show) return null;

    const testModule = tests ? tests[0] : null;
    const isEditable = user.canEditRequest;

    return (
      <div>
        <Bubble show={true}>Please select a lab for testing.</Bubble>
        <LabTestInfo editable={isEditable} />
        <hr />
        <LabTestResult testModule={testModule} />
        <div className="text-right">
          <LoaderButton
            disabled={!this.validate()}
            bsStyle="default"
            text="Save changes"
            isLoading={request.isLoading}
            onClick={this.onSaveClick}
            show={isEditable && request.id > 0}
          />
          <LoaderButton
            disabled={!this.validate()}
            bsStyle="info"
            text={<ContinueLabel />}
            isLoading={request.isLoading}
            onClick={() => submitWizardStep(wizard)}
            show={canSubmit}
          />
        </div>
      </div>
    );
  }
}

LabInfo.propTypes = {
  show: PropTypes.bool,
  canSave: PropTypes.bool,
  canSubmit: PropTypes.bool
};

LabInfo.defaultProps = {
  show: true,
  canSave: false,
  canSubmit: false
};

function mapStateToProps({ request, wizard, tests, user }) {
  return { request, wizard, tests, user };
}

export default connect(
  mapStateToProps,
  {
    updateRequest,
    submitWizardStep,
    startPreloader,
    finishPreloader,
    showNotice
  }
)(LabInfo);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/LabInfo.js